import React from 'react'

const NotFoundPage = () => {
  return (
    <div>
      Page not Found
    </div>
  )
}

export default NotFoundPage
